import axios from 'App/axios';
import { ChargebackPresignedUrl } from 'commons/services/chargebackService/chargebackServiceResponses';

const generateChargebackS3UploadUrl = async (
  orderId: string,
  contentType: string,
  storeId: string,
): Promise<ChargebackPresignedUrl> => {
  const response = await axios.post<ChargebackPresignedUrl>(
    `/admin/transactions/${orderId}/cbk-receipt-upload/url`,
    { contentType },
    { headers: { 'X-Store-Id': storeId } },
  );

  return response.data;
};

const sendChargebackDocument = async (
  orderId: string,
  key: string,
  storeId: string,
): Promise<void> => {
  await axios.post(
    `/admin/transactions/${orderId}/cbk-receipt-upload/finished`,
    { key },
    { headers: { 'X-Store-Id': storeId } },
  );
};

const getDefenseModelUrl = async (
  orderId: string,
  storeId: string,
): Promise<string> => {
  const response = await axios.get<{ url: string }>(
    `/admin/transactions/${orderId}/cbk-defense-model-url`,
    { headers: { 'X-Store-Id': storeId } },
  );

  return response.data.url;
};

const chargebackServiceBR = {
  generateChargebackS3UploadUrl,
  sendChargebackDocument,
  getDefenseModelUrl,
};

export default chargebackServiceBR;
